import { FC } from "react";
import { Wrapper } from "./Connect.styled";
import SocialLink from "Components/SocialLink";
import { AuthorsProps, PubicationsProps } from "../../types/Article.types";

interface Props {
  authors: AuthorsProps;
  title: string;
  path: string;
  publications: PubicationsProps;
}

const Connect: FC<Props> = ({ authors, title, path, publications }) => {
  if (!authors) {
    return null;
  }
  const { twitter, email } = authors[0];
  const publication = publications[0];

  return (
    <Wrapper>
      {twitter && (
        <SocialLink
          type="twitter"
          url={`https://x.com/${twitter}`}
          text={"@" + twitter}
        />
      )}
      {email && (
        <SocialLink type="email" url={`mailto:${email}`} text={email} />
      )}
    </Wrapper>
  );
};

export default Connect;
